import { PsDate } from '../../../shared/model/PsDate';

export class MonthlyPresenceFilters {
    _year = -1;
    _month = -1;
    _outsourceId = null;
    _workId = null;
    _search = '';
    _date = null;

    constructor(
        year,
        month,
        outsourceId,
        workId,
        search,
        date,
    ) {
        this._year = year;
        this._month = month;
        this._outsourceId = outsourceId;
        this._workId = workId;
        this._search = search;
        this._date = date;
    }

    static fromDefault() {
        return new MonthlyPresenceFilters(
            -1,
            -1,
            null,
            null,
            '',
            null,
        );
    }

    year() {
        return this._year;
    }

    hasYear() {
        return this._year !== -1;
    }

    setYear(year) {
        this._year = year;
    }

    month() {
        return this._month;
    }

    hasMonth() {
        return this._month !== -1;
    }

    setMonth(month) {
        this._month = month;
        this._date = new PsDate(new Date(this._year, month - 1, 1));
    }

    clearMonth() {
        this._month = -1;
        this._date = null;
    }

    outsource() {
        return this._outsourceId;
    }

    hasOutsource() {
        return this._outsourceId !== null;
    }

    setOutsource(outsourceId) {
        this._outsourceId = outsourceId;
    }

    clearOutsource() {
        this._outsourceId = null;
    }

    work() {
        return this._workId;
    }

    hasWork() {
        return this._workId !== null;
    }

    setWork(workId) {
        this._workId = workId;
    }

    clearWork() {
        this._workId = null;
    }

    search() {
        return this._search;
    }

    setSearch(search) {
        this._search = search;
    }

    date() {
        return this._date;
    }

    yearHasChanged(currentYear) {
        return this._year !== currentYear && currentYear !== -1;
    }

    monthHasChanged(currentMonth) {
        return this._month !== currentMonth && currentMonth !== -1;
    }

    yearOrMonthHasChanged(currentYear, currentMonth) {
        return this.yearHasChanged(currentYear) || this.monthHasChanged(currentMonth);
    }

    invalidYearMonth() {
        return this._year === -1 || this._month === -1;
    }

    canSearch() {
        return this.hasYear() && this.hasMonth();
    }

    clone() {
        return new MonthlyPresenceFilters(
            this._year,
            this._month,
            this._outsourceId,
            this._workId,
            this._search,
            this._date,
        );
    }

    canDownload() {
        return this.hasYear() && this.hasMonth() && this.hasOutsource();
    }

    canCreateTask() {
        return this.hasYear() && this.hasMonth() && this.hasOutsource();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/MonthlyPresenceFilters.js